import React from "react";
import "./ImageSections.css";

const ReusableImageSections = ({ images }) => {
  return (
    <>
      {images.map((img, index) => (
        <div
          key={index}
          className="cometblackimg"
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}
    </>
  );
};

export default ReusableImageSections;
